import { NavItem } from './nav-item/nav-item';
import { adminItems } from './admin';
import { nonAdminItems } from './non-admin';

/**
 * Roles that receive the full admin sidebar (matches login API `user.role`, case-insensitive).
 * Do not use substring checks like `includes('admin')` — e.g. "NonAdmin" would match incorrectly.
 */
const ADMIN_ROLE_NAMES = new Set(
  [
    'admin',
    'administrator',
    'super admin',
    'superadmin',
    'system administrator',
  ].map((r) => r.toLowerCase())
);

/** Login / stored user object shape from API (subset). */
export interface LoginUserPayload {
  id?: string;
  email?: string;
  full_name?: string;
  role?: string;
  hubs?: unknown[];
  is_superuser?: boolean;
  is_staff?: boolean;
}

export function isAdminSidebarUser(user: LoginUserPayload | null | undefined): boolean {
  if (!user) return false;
  if (user.is_superuser === true) return true;
  const role = String(user.role ?? '').trim().toLowerCase();
  return ADMIN_ROLE_NAMES.has(role);
}

export function getSidebarNavItemsForUser(user: LoginUserPayload | null | undefined): NavItem[] {
  return isAdminSidebarUser(user) ? adminItems : nonAdminItems;
}

export function readStoredLoginUser(): LoginUserPayload | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw) as LoginUserPayload;
  } catch {
    return null;
  }
}

export function getSidebarNavItemsForStoredUser(): NavItem[] {
  return getSidebarNavItemsForUser(readStoredLoginUser());
}
